import { arrayOf, shape, string } from "prop-types"

export const quartersCost = shape({
    100: arrayOf(string).isRequired,
    50: string.isRequired,
})